// Pre-baked responsive-variant loader for next/image (storefront).
//
// Product images on the CDN carry a fixed ladder of WebP variants generated at
// upload time (see admin src/modules/r2-file/variants.ts) named
// `<base>__w<W>.webp` beside the original. This loader maps next/image's
// requested width to the nearest ladder rung and points <Image> straight at that
// static object — no runtime resize, pure CDN edge cache. Keep LADDER in sync
// with the generator and the backfill script.
//
// Passthrough (return src untouched) for anything without a variant: non-CDN
// hosts, data:/blob:, the portal presigned proxy, already-variant keys, and
// non-raster formats (svg/gif). The no-404 guarantee holds because the generator
// always emits every rung (capped to the source width, never upscaled).

const LADDER = [256, 512, 1024, 1600]

// Host that actually has pre-baked variants (our public shop CDN). Derive from
// the CDN base env when present, else the known production host.
function cdnHost() {
  const base = process.env.NEXT_PUBLIC_CDN_BASE_URL
  if (base) {
    try {
      return new URL(base).host
    } catch {
      /* fall through */
    }
  }
  return "cdn.owlcat.club"
}

module.exports = function imageLoader({ src, width }) {
  if (!src || src.startsWith("data:") || src.startsWith("blob:")) return src
  if (src.includes("/api/media/")) return src // portal presigned proxy
  if (/__w\d+\.webp($|[?#])/i.test(src)) return src // already a variant

  // Only rewrite objects on the CDN that actually hold variants.
  if (!src.includes(cdnHost())) return src

  // Only raster formats have variants; svg/gif/no-extension pass through.
  if (!/\.(jpe?g|png|webp)($|[?#])/i.test(src)) return src

  const rung = LADDER.find((w) => w >= width) || LADDER[LADDER.length - 1]
  const clean = src.split(/[?#]/)[0]
  const base = clean.replace(/\.[^./]+$/, "")
  return `${base}__w${rung}.webp`
}
